import { Component, EventEmitter, inject, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { LanguageSelectorService } from '../../services/language-selector/language-selector.service';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Base } from '../../models/base';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateService } from '@ngx-translate/core';
import { PipesModule } from '../../pipes/pipes.module';
import { Language } from '../../utils/language';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule, MatSelectModule, FormsModule, MatIconModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, PipesModule, TranslateModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit, OnChanges {

  languages: any[] = [];
  selectedLanguage: string;
  languageForm: FormGroup;

  private categoryLanguage = inject(LanguageSelectorService);

  @Input() preSelectedLanguage: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() model: Base.IBase;
  @Input() alreadySelected: boolean = false;
  @Input() property: keyof LanguageSelectorComponent['model'];
  @Output() languageSelected = new EventEmitter<Language>();

  ngOnInit(): void {
    this.languageForm = new FormGroup({
      selectedLanguage: new FormControl(this.preSelectedLanguage, Validators.required)
    });

    this.categoryLanguage.getLanguages().subscribe(data => {
      this.languages = data;
    });

    if (this.alreadySelected) {
      this.languageForm.get('selectedLanguage')?.disable();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['alreadySelected'] && this.alreadySelected) {
      this.languageForm?.get('selectedLanguage')?.disable();
    }
  }

  setLanguageSelected(lang: any) {
    if (this.alreadySelected) {
      return; 
    }
    this.selectedLanguage = lang;
  }

  emitLanguageChange(lang: Language): void {
    if (this.alreadySelected) {
      return;  
    }

    const selectedLanguage = this.languages.find(elem => elem.code === lang);
    this.languageSelected.emit(selectedLanguage);
    this.languageForm.get('selectedLanguage')!.setValue(selectedLanguage);
  }

  get selectedLanguageControl(): FormControl {
    return this.languageForm?.get('selectedLanguage') as FormControl;
  }

  getErrorMessage() {
    const error = this.model?.__errorByField[this.property];
    if (error) {
      return error;
    }
    if (this.selectedLanguageControl.hasError('required')) {
      return 'general.field_required';
    }
    return '';
  }

  markAsTouched() {
    this.languageForm.markAllAsTouched();
  }
}
